<template>
    <div class="dataTables_wrapper dt-bootstrap4 no-footers">
        <!--
        <div class="tableFilters">
            <div class="row mb-3">
                <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-start">
                    <div id="dt-basic-example_filter" class="dataTables_filter">
                        <label v-if="parametersGrid.input_search">
                            Buscar:
                            <input class="form-control border-top-left-radius-0 border-bottom-left-radius-0 ml-0 width-lg shadow-inset-1" type="text" v-model="tableData.search" placeholder="Search Table" @input="getProjects()" />
                        </label>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-end">
                   <div class="dataTables_length" id="dt-basic-example_length">
                        <label>
                            Mostrar 
                            <select class="form-control " v-model="tableData.length" @change="getProjects()">
                                <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                            </select>
                            registros
                        </label>
                    </div>
                </div>
            </div>
        </div>
        -->

        <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr v-for="(project,index) in projects" :key="project.id" 
                    @click="selectFile($event,index)"
                    :class="[selectIndex === index ? 'selected':'']"
                >
                   <td v-for="(val, key) in columns" :key="key">
                       <slot name="table-row" :column="val" :row="project">
                            <div v-if="val.html" v-html="project[val.name]"></div>
                            <div v-else>{{project[val.name]}}</div>
                       </slot>
                   </td>
                </tr>
            </tbody>
        </datatable>

        <pagination 
            ref="pagination"
            @prev="goTo"
            @next="goTo">
        </pagination>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex';

    import Pagination from '@/components/Pagination.vue';
    import Datatable from  '@/components/Datatable.vue';

    export default {
        components:{ datatable: Datatable, pagination: Pagination},
        props:{
            parametersGrid:{
                type:Object,
                default:()=>{}
            },
            searchExternal:{
                type:Object,
                default:()=>{}
            },
            searchExternalLike:{
                type:Object,
                default:()=>{}
            },
        },
        created() {
            this.getProjects();
        },
        data(){
            let sortOrders = {};
            let serachColumns = [];

            let columns = this.parametersGrid.columns;

            columns.forEach((column) => {
                sortOrders[column.name] = -1;
                serachColumns.push(column.name);
            });
            
            return {
                projects: [],
                columns: columns,
                sortKey: this.parametersGrid.primaryKey,
                sortOrders: sortOrders,
                perPage: ['10', '20', '30'],
                tableData: {
                    draw: 0,
                    length: 10,
                    search: "",
                    input_search: this.parametersGrid.input_search,
                    column: this.parametersGrid.primaryKey,
                    dir: 'desc',

                    action: this.parametersGrid.action,
                    controller: this.parametersGrid.url,
                    columns: serachColumns,
                    columnsOtherSearch:this.searchExternal,
                    columnsOtherSearchLike: this.searchExternalLike,
                },
                selectIndex:-1,
                selectedRow:null
            }
        },
        methods: {
            ...mapMutations(['setLoading']),
            reset(){
                this.selectIndex=-1;
                this.selectedRow=null;
            },
            getProjects(url = this.parametersGrid.url+"/"+this.parametersGrid.action) {
                this.reset();
                this.tableData.draw++;
                this.setLoading(true);
                this.$http.get(url, {params: this.tableData}).then(response => {
                    let data = response.data;

                    this.projects = data.data;
                    this.$refs.pagination.setData(data);
                    this.setLoading(false);
                }).catch(errors => {
                    console.log(errors);
                });
            },
            goTo(url){
                this.getProjects(url);
            },
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                this.tableData.column = key;
                this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
                this.getProjects();
            },
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },
            reload(){
                this.getProjects();
            },
            selectFile(event,index){
                this.selectIndex=index;
                this.selectedRow=this.projects[index];
                this.$emit('selected',this.selectedRow);
            },
            getSelectedRow() {
                return this.selectedRow;
            },
        }
    }
</script>